import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { tokenVerification } from './Utils';

class SurveyMilestone extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startLoader: false,
            loadedData: [],
            disableAddButton: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            pageNum: null,
            paginationValue: 10,
            mileStones: "",
            selectedMilestoneName: "",
            selectedMilestoneId: "",
            milestoneStart: "",
            milestoneEnd: "",
            isLoading: true,
            noDataMessage: "",
            noMilestonedisableAdd: true

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    componentDidMount() {
        localStorage.setItem("active-tab-of-manage-admission", "episodes");
        this.fetchSurveyMilestones();
        this.fetchMileStones();
    }

    fetchMileStones() {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-milestones",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                treatmentId: this.props.location.state.treatmentId,
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.mileStones = res.result;
                        thisController.state.noMilestonedisableAdd = false;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMilestonedisableAdd = false;
                        thisController.state.noDataMessage = "There is no milestones added for this treatment, Please add"
                        thisController.setState(thisController.state);
                    }

                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }




    addEmptyRow = () => {

        console.log("Adding Empty Row");
        var thisController = this;
        if (thisController.state.mileStones == "") {
            console.log("Empty milestones");
            thisController.notifyEmptyTreatmentMilestones();
        } else {
            thisController.state.paginationValue = thisController.state.paginationValue + 5;
            if (thisController.state.pageNum != 0) {
                thisController.setState({ pageNum: 0 })
            }
            thisController.state.selectedMilestoneName = "";
            thisController.state.milestoneStart = "";
            thisController.state.milestoneEnd = "";
            var row = {
                id: "",
                    milestoneName: "",
                    milestoneStart: "",
                    milestoneEnd: "",
            }
            var allData = [row, ...thisController.state.loadedData];
            thisController.state.loadedData = allData;
            thisController.state.editedId = "";
            thisController.state.disableAddButton = true;
            thisController.setState(thisController.state);
        }
    }



    notifyEpisodeAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode added successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        }, { toastId: "empty1" });

    }

    notifyEmptyTreatmentMilestones() {
        // toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;There are no milestones currently defined for this treatment.  Milestones may be added using the treatment milestone button on the Engagement tab.</b>, {
            position: "top-center"
        }, { toastId: "nomilestone" });

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>{this.state.noDataMessage}</p>
        </div>
    );



    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }



    notifuEpisodeUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode details updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }



    makeCelledit(props, e) {
        this.markAsBeingEdited(props);
    }

    markAsBeingEdited(props) {
        this.state.editedId = props.id;
        this.state.selectedMilestoneId = props.milestoneId;
        this.state.selectedMilestoneName = props.milestoneName;
        this.state.milestoneEnd = props.milestoneEnd;
        this.state.milestoneStart = props.milestoneStart;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }


    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.milestoneName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteSurveyMilestone(props.id)
                },
                {
                    label: 'No',
                }
            ],
            overlayClassName: "confirmAlertStyle"
        });
    }


    deleteSurveyMilestone = (id) => {
        var deleteApiController = this

        $.ajax({
            url: "/my-jeeva-api/delete-survey-milestone/" + id,

            method: "DELETE",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    deleteApiController.state.loadedData = "";
                    deleteApiController.setState(deleteApiController.state);
                    deleteApiController.fetchSurveyMilestones();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    fetchSurveyMilestones = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-survey-milestones",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                surveyId: this.props.location.state.surveyId,
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.loadedData = res.result;
                        thisController.state.isLoading = false;
                        thisController.state.disableAddButton = false;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);

                    }

                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }


    refreshData = (e) => {
        // e.preventDefault();

        this.setState({
            disableAddButton: false,
            editedId: "-1",
            isLoading: true,
            loadedData: [],

        });
        this.fetchSurveyMilestones();
    };


    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Episode detail deleted successfully</b>, {
            position: "top-center",
        });
    }




    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyEmptyMilestoneName(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please select milestone</b>, {
            position: "top-center",
            color: "red"
        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }




    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a;
        var b;
        if (field === "milestoneStart" || field === "milestoneEnd") {
            a = rowA[field] ? rowA[field] : "";
            b = rowB[field] ? rowB[field] : "";

        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }
        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };



    handleDropdownChange = (event) => {
        const selectedMilestoneName = event.target.value;
        const selectedMilestone = this.state.mileStones.find(
            (milestone) => milestone.mileStoneName === selectedMilestoneName
        );

        this.setState({
            selectedMilestoneId: selectedMilestone ? selectedMilestone.id : "",
            selectedMilestoneName,
        });
    };


    saveSurveyMilestone = () => {
        var thisController = this;

        if (thisController.state.selectedMilestoneName == "") {
            thisController.notifyEmptyMilestoneName();
        } else {
            var surveyMilestoneData = {
                surveyId: this.props.location.state.surveyId,
                milestoneName: thisController.state.selectedMilestoneName,
                milestoneId: thisController.state.selectedMilestoneId,
                milestoneStart: thisController.state.milestoneStart,
                // milestoneEnd: thisController.state.milestoneEnd
            }

            $.ajax({
                url: "/my-jeeva-api/save-survey-milestone",
                method: "POST",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(surveyMilestoneData),

                success: function (res) {
                    if (res.success === true) {
                        thisController.fetchSurveyMilestones();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                },
            });
        }

    }

    updateSurveyMilestone = (props) => {
        var thisController = this;

        var surveyMilestoneData = {
            id: props.id,
            surveyId: this.props.location.state.surveyId,
            milestoneName: thisController.state.selectedMilestoneName,
            milestoneId: thisController.state.selectedMilestoneId,
            milestoneStart: thisController.state.milestoneStart,
            milestoneEnd: thisController.state.milestoneEnd
        }

        $.ajax({
            url: "/my-jeeva-api/update-survey-milestone",
            method: "PATCH",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: JSON.stringify(surveyMilestoneData),

            success: function (res) {
                if (res.success === true) {
                    thisController.state.editedId = "-1";
                    thisController.fetchSurveyMilestones();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }

    handleMilestoneStartChange = (e) => {
        this.state.milestoneStart = e.target.value;
        this.setState(this.state);
    }

    handleMilestoneEndChange = (e) => {
        this.state.milestoneEnd = e.target.value;
        this.setState(this.state);
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/survey",
            state: {
                pageNum: pageNum,
            }
        });
    }

    render() {
        const { loadedData } = this.state;

        const milestone_column = [


            {
                name: <b>Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('milestoneName'),
                selector: (props) => (
                    <div name="name">
                        <div
                            className="textarea"
                            style={{
                                background: 'white',
                                height: '2.7em',
                                resize: 'none',
                                paddingLeft: '2px',
                                paddingTop: '6px',
                                width: '98%',
                                border: props.id === '' || props.id === this.state.editedId ? '1px solid #D2D4DC' : 'none',
                                borderRadius: props.id === '' ? '2px' : 'none',
                            }}
                        >
                            {props.id === this.state.editedId ? (
                                <select
                                    value={this.state.selectedMilestoneName}
                                    onChange={this.handleDropdownChange}
                                >
                                    <option value="" disabled hidden>
                                        Select a milestone
                                    </option>
                                    {this.state.mileStones &&
                                        this.state.mileStones.map((selectedMileStone, index) => (
                                            <option key={index} value={selectedMileStone.mileStoneName}>
                                                {selectedMileStone.mileStoneName}
                                            </option>
                                        ))}
                                </select>
                            ) : (
                                <span>{props.milestoneName || 'N/A'}</span>
                            )}
                        </div>
                    </div>
                ),
            },
            {
                name: <b>Survey availability relative to the milestone</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('milestoneStart'),
                selector: (props) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {props.id === this.state.editedId ? (
                            <input
                                type='number'
                                value={this.state.milestoneStart}
                                onChange={this.handleMilestoneStartChange}
                            />
                        ) : (
                            <span>
                                {props.milestoneStart}
                            </span>

                        )}
                    </div>
                ),
            },

            {
                name: <b>Actions</b>,
                width: 20,
                selector: (props) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginLeft: '-6px' }}
                        disabled = {(this.userDetails["userRole"] === "PHYSICIAN" &&
                                this.userDetails["emailId"] !== this.props.location.state.createdByEmail) } >
                            <img className="img-responsive"
                                title={(props.id == "") ||
                                    (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', 
                                    // backgroundColor: '#282a65', 
                                    backgroundColor : (this.userDetails["userRole"] === "PHYSICIAN" &&
                                        this.userDetails["emailId"] !== this.props.location.state.createdByEmail) ? "#282a6596" : "#282a65",
                                    borderRadius: '5px', padding: '1px' }}
                                src={(props.id == "") ? this.saveImageSrc : ((props.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.saveSurveyMilestone(props, e)
                                        :
                                        (props.id == this.state.editedId) ?
                                            this.updateSurveyMilestone(props, e)

                                            : this.makeCelledit(props, e);
                                }}
                            />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', 
                                    backgroundColor: '#282a65', 
                                    backgroundColor : (this.userDetails["userRole"] === "PHYSICIAN" &&
                                        this.userDetails["emailId"]!== this.props.location.state.createdByEmail) ? "#282a6596" : "#282a65",
                                    borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.id) === '' ?
                                    this.fetchSurveyMilestones()
                                    :
                                    this.openDeletePopUp(props)
                                }

                            /></button>
                    </div>), width: 100
            },
        ]
        return (
            <div style={{ marginRight: '1%' }} id='painDataTab'>

                <div style={{ background: "#F9F9FB", overflowY: 'scroll', overflowX: 'hidden', height: '60vh' }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/painDataSchedule.css" />
                    <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />


                    <div className="row" style={{ marginLeft: '14px' }}>

                        <div style={{ marginTop: '75px' }}  >
                            <img src="assets/images/arrow.svg"
                                style={{ paddingRight: "30%", cursor: 'pointer' }}
                                onClick={this.goBackFromSubTab}
                            />
                        </div>


                        <div className="patient-info-container"
                            style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "55vw" }}
                        >
                            <div className="patient-info-box">
                                <strong>Treatment Name</strong>
                                <p>{this.props.location.state.treatmentName}</p>
                            </div>
                            <div className="patient-info-box">
                                <strong> Survey Name</strong>
                                <p>{this.props.location.state.surveyName}</p>
                            </div>


                        </div>
                        <div className="col-sm-3" style={{ marginTop: '45px' }}>
                            <div className="d-flex flex-row-reverse pt-2">

                                <div className="p-2" style={{ marginBottom: '10px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        disabled={this.state.noMilestonedisableAdd || (this.userDetails["userRole"] === "PHYSICIAN" &&
                                            this.userDetails["emailId"] !== this.props.location.state.createdByEmail)} 
                                        onClick={this.state.disableAddButton ? this.notifyMsgFieldEmpty : this.addEmptyRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ textAlign: 'left' }}>
                        <h6 className="nav-item" style={{ color: '#282a65', marginTop: '2vh', marginLeft: "1vw" }}>
                            Select a milestone then enter the number of days before (-) and after (+) the milestone that the survey should be displayed to patients.  Leave blank for no start or end date.</h6>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length === 0 && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There is no survey milestone scheduled. </p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.loadedData.length > 0 &&
                                    (<DataTable
                                        data={loadedData}
                                        columns={milestone_column}
                                        defaultPageSize={5}
                                        pageSizeOptions={[5, 10, 15]}
                                        onPageChange={this.onPageChange}
                                        pagination={this.state.paginationValue}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />)}
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default SurveyMilestone;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/SurveyMilestone.js